import { gql, useQuery } from "@apollo/client";

import { FieldFilterDefinition } from "../../generated/gql/graphql";

type GraphicFilterApi = {
  loading: boolean;
  error: any;
  fieldFilters: FieldFilterDefinition[];
  selected: any;
};

const GET_GRAPHIC_FILTER_OPTIONS = gql`
  query GraphicFilters {
    graphicFilters {
      fieldName
      name
      options {
        label
        value
      }
    }
  }
`;

export default function useGraphicFilters(): GraphicFilterApi {
  const { data, loading, error } = useQuery(GET_GRAPHIC_FILTER_OPTIONS);

  return {
    loading,
    error,
    fieldFilters: data?.graphicFilters || [],
    selected: [],
  };
}
